import { CloseIcon, DownArrowIcon, InfoIcon, LinkIcon } from '@sketchnote/icons';
// import { Switch } from '../switch';
import { Avatar, Button, MenuItemProps, MoreActionMenu } from '@sketchnote/shared-components';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import * as React from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';

import { useWorkspaceAccess } from '../hooks/useWorkspaceAccess';
import { ResultOptionType } from './share-types';

const { useState } = React;

export const Header = () => {
  return (
    <>
      <div className="flex items-center p-20 pb-10">
        <h3 className="font-medium">Invite collaborators</h3>
        <span role="button" className="ml-auto">
          <CloseIcon wrapperClass="align-middle text-gray-500" />
        </span>
      </div>
    </>
  );
};

export const Footer = ({
  shouldShowPublicLink = false,
  hasSelectedOptions = false,
}: {
  shouldShowPublicLink: boolean;
  hasSelectedOptions: boolean;
}) => {
  if (shouldShowPublicLink && !hasSelectedOptions) {
    return (
      <div className="flex text-sm items-center absolute bottom-0 rounded-b-lg bg-gray-100 p-22 w-full">
        <LinkIcon />
        <span className="ml-8">Public link</span>
        {/* <Switch className="ml-auto" /> */}
      </div>
    );
  } else {
    return (
      <div className="flex border-t border-gray-100 text-sm items-center absolute bottom-0 rounded-b-lg p-16 w-full">
        <Button className="ml-auto" disabled={!hasSelectedOptions}>
          Invite
        </Button>
      </div>
    );
  }
};

export const AccessDropdownMenu = ({ title, subTitle }: { title: string; subTitle?: string }) => (
  <div className="w-auto">
    <p>{title}</p>
    <p className="text-gray-500 font-regular">{subTitle}</p>
  </div>
);

export const AccessDropdown = ({
  menuItems,
  onClickMenuItem,
  accessLevel = '',
  isReadOnly = false,
  isAdmin = false,
}: {
  menuItems: { title: string; subTitle?: string; value: string }[];
  onClickMenuItem?: (value: string) => void;
  accessLevel?: string;
  isReadOnly?: boolean;
  isAdmin?: boolean;
}) => {
  const [access, setAccess] = useState(accessLevel ? accessLevel : menuItems[0].value);

  const { isFullAccess: isFullWSAccess } = useWorkspaceAccess();

  const isFullAccess = isFullWSAccess || access === 'admin';

  const handleMenuClick = (menuitem: MenuItemProps) => {
    if (onClickMenuItem && menuitem.value) {
      onClickMenuItem(menuitem.value);
    }
    if (menuitem.value) {
      setAccess(menuitem.value);
    }
  };

  return (
    <div className="flex text-gray-600 items-center text-sm gap-4">
      {isAdmin && !isFullAccess ? (
        <Tippy
          content="This person can still edit workspace properties because they have admin rights"
          className="w-auto h-auto bg-gray-999"
        >
          <div>
            <InfoIcon className="mt-4" />
          </div>
        </Tippy>
      ) : (
        <></>
      )}
      <span>{menuItems.filter((item) => item.value === access)[0]?.title}</span>
      <MoreActionMenu
        disabled={!isFullAccess || isReadOnly}
        menuItems={menuItems.map((item) => ({
          label: <AccessDropdownMenu title={item.title} subTitle={item?.subTitle} />,
          value: item.value,
          isActive: item.value === access,
        }))}
        icon={isFullAccess && !isReadOnly ? <DownArrowIcon wrapperClass="mt-4" /> : <></>}
        onClickMenuItem={handleMenuClick}
      />
    </div>
  );
};

export const TeamMembers = () => {
  return (
    <div>
      <div className="bg-gray-100 px-20 py-10 text-sm ">Team members</div>
      <UsersResultsShare id={'100'} email="james@mendesaltaren.com" username="James" />
    </div>
  );
};

interface UsersResultsShareProps extends ResultOptionType {
  onClick?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
  onMouseEnter?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
  className?: string;
  role?: string;
}

export const UsersResultsShare = ({
  username,
  email,
  avatar,
  isActive = false,
  role,
  onClick,
  onMouseEnter,
  className,
}: UsersResultsShareProps) => {
  const me = useAuth((s) => s.userDetails);
  const wrapperClass = classNames({
    'flex  py-6 text-sm m-4 rounded-md items-center cursor-pointer': true,
    // 'bg-gray-100': isActive,
    [className || '']: !!className,
  });

  return (
    <div
      key={username}
      className={wrapperClass}
      onClick={onClick}
      tabIndex={0}
      onMouseEnter={onMouseEnter}
    >
      <Avatar
        wrapperClassName="mr-12"
        name={username ? username : email}
        size="md"
        src={avatar}
        type="photo"
        tooltip={false}
      />

      <div>
        <p className="font-medium text-gray-999 text-xs">
          {username}
          {me?.email === email && <span className="text-gray-500"> (You)</span>}
        </p>
        <p className="text-xs">
          {role === 'guest' && (
            <span className="text-blue-500 font-medium">
              {role[0].toUpperCase() + role.substring(1)} -{' '}
            </span>
          )}
          <span className="text-gray-500">{email}</span>
        </p>
      </div>
    </div>
  );
};
